import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';

import { StatusBoleto } from '../_models/dominio/statusBoleto';
import { StatusEmail } from '../_models/dominio/statusEmail';
import { TipoCedente } from '../_models/dominio/tipoCedente';
import { TipoInscricao } from '../_models/dominio/tipoInscricao';
import { TipoRegistroTitulo } from '../_models/dominio/tipoRegistroTitulo';
import { TipoMoeda } from '../_models/dominio/tipoMoeda';
import { StatusUsuario } from '../_models/dominio/statusUsuario';
import { Estado } from '../_models/dominio/estado';
import { Observable } from 'rxjs';
import { Municipio } from '../_models/dominio/municipio';

export const HTTP_OPTIONS = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Access-Control-Allow-Credentials' : 'true',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PATCH, DELETE, PUT, OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
  })
};


@Injectable({ providedIn: 'root' })
export class DominioService {
  constructor(private http: HttpClient) { }

  getAllStatusBoleto() {
    return this.http.get<StatusBoleto[]>(`${environment.authorizedUrls.bsCobrancaUrl}/dominio/listarStatusBoleto`);
  }

  getAllStatusEmail() {
    return this.http.get<StatusEmail[]>(`${environment.authorizedUrls.bsCobrancaUrl}/dominio/listarStatusEmail`);
  }

   getAllTipoCedente() {
    return this.http.get<TipoCedente[]>(`${environment.authorizedUrls.bsCobrancaUrl}/dominio/listarTipoCedente`);
  }

   getAllTipoInscricao() {
    return this.http.get<TipoInscricao[]>(`${environment.authorizedUrls.bsCobrancaUrl}/dominio/listarTipoInscricao`);
  }

   getAllTipoRegistroTitulo() {
    // tslint:disable-next-line: max-line-length
    return this.http.get<TipoRegistroTitulo[]>(`${environment.authorizedUrls.bsCobrancaUrl}/dominio/listarTipoRegistroTitulo`);
  }

   getAllTipoMoeda() {
    return this.http.get<TipoMoeda[]>(`${environment.authorizedUrls.bsCobrancaUrl}/dominio/listarTipoMoeda`);
  }

  getAllStatusUsuario() {
    return this.http.get<StatusUsuario[]>(`${environment.authorizedUrls.bsCobrancaUrl}/dominio/listarStatusUsuario`);
  }

  getAllEstado(): Observable<Estado[]> {
    return this.http.get<Estado[]>(`${environment.authorizedUrls.bsCobrancaUrl}/dominio/listarEstados`);
  }

  getAllMunicipioEstado(uf: string): Observable<Municipio[]> {
    return this.http.get<Municipio[]>(`${environment.authorizedUrls.bsCobrancaUrl}/dominio/listarMunicipio/` + uf);
  }
}
